//export const API_URL = 'http://localhost/elog2/public/api/';
export const API_URL = 'https://elog2.etslogistika.ee/api/';

export const EXCLUSION_CATEGORY_TYPE = 1;
export const ESTONIA_ID = 45;
